import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "valid",
  "use": "valid-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"valid\"><g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"40\" height=\"40\" fill=\"#77E9AD\" rx=\"20\" /><path stroke=\"#000\" d=\"M12.5 20.09L17.795 25l9.705-9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol